import apollo from "./apollo.json"
import appBar from "./appBar.json"
import checklists from "./checklists.json"
import common from "./common.json"
import contacts from "./contacts.json"
import developerPortal from "./developerPortal.json"
import documentTypes from "./documentTypes.json"
import documents from "./documents.json"
import drivers from "./drivers.json"
import dynamicWorkflow from "./dynamicWorkflow.json"
import finance from "./finance.json"
import fleets from "./fleets.json"
import formArchive from "./formArchive.json"
import forms from "./forms.json"
import geofence from "./geofence.json"
import globalNotifications from "./globalNotifications.json"
import governanceDocuments from "./governanceDocuments.json"
import home from "./home.json"
import invoiceApproval from "./invoiceApproval.json"
import invoices from "./invoices.json"
import items from "./items.json"
import jobAllocation from "./jobAllocation.json"
import jobs from "./jobs.json"
import journeyHistory from "./journeyHistory.json"
import labels from "./labels.json"
import licenceClasses from "./licenceClasses.json"
import loaders from "./loaders.json"
import locations from "./locations.json"
import login from "./login.json"
import manageSubscription from "./manageSubscription.json"
import marketplace from "./marketplace.json"
import meta from "./meta.json"
import notifications from "./notifications.json"
import payments from "./payments.json"
import permission from "./permissions.json"
import plugins from "./plugins.json"
import popPodTemplates from "./popPodTemplates.json"
import priceLists from "./priceLists.json"
import projects from "./projects.json"
import quickMenu from "./quickMenu.json"
import settings from "./settings.json"
import shiftTemplates from "./shiftTemplates.json"
import shifts from "./shifts.json"
import sideBar from "./sideBar.json"
import sites from "./sites.json"
import subcontractors from "./subcontractors.json"
import subscriptionSuccess from "./subscriptionSuccess.json"
import templates from "./templates.json"
import terms from "./terms.json"
import tracker from "./tracker.json"
import trailerClasses from "./trailerClasses.json"
import trailers from "./trailers.json"
import userInvitations from "./userInvitations.json"
import users from "./users.json"
import vehicleClasses from "./vehicleClasses.json"
import vehicles from "./vehicles.json"

export default {
    common,
    meta,
    appBar,
    quickMenu,
    sideBar,
    apollo,
    home,
    login,
    jobAllocation,
    jobs,
    projects,
    documents,
    tracker,
    geofence,
    dynamicWorkflow,
    fleets,
    locations,
    drivers,
    subcontractors,
    users,
    userInvitations,
    contacts,
    vehicles,
    loaders,
    licenceClasses,
    vehicleClasses,
    checklists,
    items,
    terms,
    shifts,
    trailers,
    trailerClasses,
    documentTypes,
    invoices,
    payments,
    settings,
    notifications,
    globalNotifications,
    marketplace,
    plugins,
    developerPortal,
    templates,
    labels,
    manageSubscription,
    subscriptionSuccess,
    popPodTemplates,
    priceLists,
    governanceDocuments,
    forms,
    permission,
    sites,
    journeyHistory,
    shiftTemplates,
    finance,
    formArchive,
    invoiceApproval,
}
